import React from "react";
import { NavLink } from "react-router-dom";

import linkIsActive from "../utils/linkIsActive";

interface SidebarLinkProps {
  Icon: (props: React.ComponentProps<"svg">) => JSX.Element;
  to: string;
  label: string;
}

const SidebarLink: React.FC<SidebarLinkProps> = ({ Icon, to, label }) => {
  return (
    <NavLink to={to} className={linkIsActive}>
      <Icon className="primary-icon md:w-10 md:h-10" />
      <p className="hidden md:block text-2xl capitalize font-medium">{label}</p>
    </NavLink>
  );
};

export default SidebarLink;
